import classNames from 'classnames';
import Image from 'next/image';

import { SectionTitle, TextBlock, Button } from '@/ui/index';
import { ArrRight } from '@/icons/index';

import styles from './InfoBlock.module.scss';

const InfoTable = ({ data, className }) => {
  const renderButtonList = (item, index) => {
    return (
      <Button
        className={styles.info__button}
        variant='gray'
        key={index}
        Component={'a'}
        href={item?.link}
        download
      >
        {item?.icon && (
          <Image
            src={item?.icon}
            alt={item?.text}
            title={item?.text}
            height={24}
            width={24}
            loading='lazy'
          />
        )}
        {item?.text}
        <ArrRight />
      </Button>
    );
  };

  return (
    <section className={classNames(styles['info-block'], className)}>
      {data?.title && (
        <SectionTitle
          titleModify={classNames(styles['info-block__title'], 'title--large')}
        >
          {data.title}
        </SectionTitle>
      )}
      <div className={styles['info-block__inner']}>
        <div className={styles.info}>
          {data?.description && (
            <TextBlock
              className={classNames(styles.info__text, 'text--large')}
              isHtml
            >
              {data.description}
            </TextBlock>
          )}
          {data?.download_buttons && (
            <div className={styles.info__buttons}>
              {data.download_buttons.map(renderButtonList)}
            </div>
          )}
          {data?.note && (
            <TextBlock
              className={classNames(styles['info__add-text'], 'text--small')}
            >
              {data.note}
            </TextBlock>
          )}
        </div>
        {data?.image && (
          <div className={styles['img-block']}>
            <Image
              src={data?.image}
              alt={data?.title}
              title={data?.title}
              layout='fill'
              loading='lazy'
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default InfoTable;
